import { CUSTOMERS_MENU_ID, PLATFORM_MENU_ID, RESOURCES_MENU_ID, SOLUTIONS_MENU_ID, TEAMS_MENU_ID } from "segments/desktop/header/layouts/base-header/base-header-service";
export const MENU_ID_TO_EVENT_KIND_MAP = {
    [SOLUTIONS_MENU_ID]: "Products",
    [TEAMS_MENU_ID]: "Teams",
    [PLATFORM_MENU_ID]: "Platform",
    [CUSTOMERS_MENU_ID]: "Success stories",
    [RESOURCES_MENU_ID]: "Resources"
};
